import type { SipPlansCategory, SipStopRecommendation } from '../../../../api/sipPlan.types'
import { SipCategoryBucketKey, SIP_CATEGORY_BUCKET_TITLES, SipPlanMode, type SipActionFilter } from '../../../../api/types'
import { useSipPlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/BucketAccordion'
import { StopSipFundCard } from '../cards/StopSipFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../../analytics/plansEvents'

type StopSipBucketAccordionProps = {
  category: SipPlansCategory
  categoryId: string
  actionFilter: SipActionFilter
  isBorderTop?: boolean
}

export function StopSipBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: StopSipBucketAccordionProps) {
  const stopRecommendations = getCategoryBucketItems<SipStopRecommendation>(category?.stopRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = useSipPlanCategoryBucket({
    planMode: SipPlanMode.YOUR_PLAN,
    actionFilter,
    categoryId,
    bucketKey: SipCategoryBucketKey.stopRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.stopRecommendations]}
      count={stopRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.SipYourPlan,
            eventId: PlansSipListEventIds.BucketAccordion,
            buttonLabel: SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.stopRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {stopRecommendations.map((recommendation, recommendationIndex) => (
        <StopSipFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          showBottomDivider={recommendationIndex < stopRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
